module.exports = __webpack_public_path__ + "static/media/booked_pass.bfede702.svg";